import {Component} from '@angular/core';
import {MatInputModule} from '@angular/material/input';
import {AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {AuthService} from '../../../shared/services/auth.service';
import {CardsBasicComponent} from "../../../shared/components/cards/cards-basic/cards-basic.component";
import {MatButton} from "@angular/material/button";
import {formatPhoneNumber, phoneNumberValidator} from "../../../shared/validators/phone-validator";
import {NgIf} from "@angular/common";
import {SnackbarService} from "../../../shared/services/snackbar.service";
import {Router, RouterLink,} from "@angular/router";
import {AlertMessage} from "../../interfaces/alert.interface";
import {AlertsComponent} from "../../../shared/components/alerts/alerts.component";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-register',
  standalone: true,
  imports: [MatInputModule, FormsModule, CardsBasicComponent, ReactiveFormsModule, MatButton, NgIf, AlertsComponent, RouterLink, LocalizeRouterPipe],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})

export class RegisterComponent {
  user = {email: '', phoneNumber: '', password: ''};
  isLoading: boolean = false;
  alertData: AlertMessage | null = null;

  registerForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    //phoneNumber: new FormControl('', [Validators.required, phoneNumberValidator()]),
    password: new FormControl('', [Validators.required]),
    confirmPassword: new FormControl('', [Validators.required])
  }, { validators: this.passwordMatchValidator });

  constructor(private authService: AuthService,
              private snackbarService: SnackbarService,
              private router: Router,
              private translate: TranslateService) {
  }

  // Custom Validator: Überprüft, ob password und confirmPassword übereinstimmen.
  passwordMatchValidator(formGroup: AbstractControl): { [key: string]: boolean } | null {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { mismatch: true };
  }


  register(): void {
    if (this.registerForm.invalid) {
      return;
    }
    this.isLoading = true;
    //const phoneNumber = this.registerForm.value.phoneNumber || '';
    this.user.email = this.registerForm.value.email || '';
    //this.user.phoneNumber = formatPhoneNumber(phoneNumber);
    this.user.password = this.registerForm.value.password || '';

    this.authService.register(this.user).subscribe({
      next: (res: any) => {
        this.snackbarService.show(res.message);
        this.isLoading = false;
      },
      error: (err: any) => {
        if (err.error) {
          this.setAlertData(err.error.error || 'An unexpected error occurred. Please try again.', 'error');
        } else {
          this.setAlertData('An unexpected error occurred. Please try again.', 'error');
        }
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
        const currentLang = this.translate.currentLang || 'en';
        this.router.navigate([`/${currentLang}/login`]);
        //this.router.navigate(['/login']);
      }
    });
  }

  /**
   * This function takes user input and assigns it to an alert object.
   *
   * @function
   * @param {() => string} inputFunction - A function that takes no arguments and returns a string.
   * @returns {AlertMessage} The constructed alert object.
   */
  private setAlertData(message: string, type: 'error' | 'success' | 'warning'): void {
    this.alertData = { message, type };
  }

}
